export default "<router-outlet></router-outlet>\r\n<p-toast key=\"general-toast\"></p-toast>\r\n"